import { request } from '../api/client.js'
import type { ContentDashboard, ContentTopicSource, DiagnosticDetail } from './types.js'
import type { RevisionComparison, RevisionDetail, RevisionHistory, RevisionKind, RevisionLifecycleOperation, RevisionLifecycleRequest, RevisionLifecycleResult, RevisionList } from './revision-types.js'

export const adminContentClient = {
  async revisions(kind: RevisionKind, identityId: string, page = 1, limit = 20): Promise<RevisionList> {
    return request(`/coach/admin/content/revisions/${kind}/${encodeURIComponent(identityId)}?page=${page}&limit=${limit}`, { method: 'GET' })
  },
  async revisionHistory(kind: RevisionKind, identityId: string, page = 1, limit = 20): Promise<RevisionHistory> {
    return request(`/coach/admin/content/revisions/${kind}/${encodeURIComponent(identityId)}/history?page=${page}&limit=${limit}`, { method: 'GET' })
  },
  async revision(kind: RevisionKind, identityId: string, revisionId: string): Promise<RevisionDetail> {
    return request(`/coach/admin/content/revisions/${kind}/${encodeURIComponent(identityId)}/${encodeURIComponent(revisionId)}`, { method: 'GET' })
  },
  async compareRevisions(kind: RevisionKind, identityId: string, fromRevisionId: string, toRevisionId: string): Promise<RevisionComparison> {
    const query = new URLSearchParams({ fromRevisionId, toRevisionId })
    return request(`/coach/admin/content/revisions/${kind}/${encodeURIComponent(identityId)}/compare?${query}`, { method: 'GET' })
  },
  async changeRevisionLifecycle(kind: RevisionKind, identityId: string, revisionId: string, operation: RevisionLifecycleOperation, body: RevisionLifecycleRequest): Promise<RevisionLifecycleResult> {
    return request(`/coach/admin/content/revisions/${kind}/${encodeURIComponent(identityId)}/${encodeURIComponent(revisionId)}/${operation}`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },
  async detail(page: import('./catalog-detail-page').DetailPage, id: string): Promise<import('./catalog-detail-page').CatalogDetail> {
    return request(`/coach/admin/content/catalog/${page}/${encodeURIComponent(id)}`, { method: 'GET' })
  },
  async list(page: import('./catalog-navigation.js').CatalogPage, params: import('./catalog-types.js').CatalogListParams): Promise<import('./catalog-types.js').CatalogResult> {
    const query = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) value.forEach(term => query.append(key, term))
      else if (value !== undefined && value !== '') query.set(key, String(value))
    }
    return request(`/coach/admin/content/catalog/${page}?${query}`, { method: 'GET' })
  },
  async get(): Promise<ContentDashboard> {
    return request<ContentDashboard>('/coach/admin/content', { method: 'GET' })
  },
  async getDiagnostic(programId: string): Promise<DiagnosticDetail> {
    return request<DiagnosticDetail>(`/coach/admin/content/diagnostics/${encodeURIComponent(programId)}`, { method: 'GET' })
  },
  async getTopicSource(topicId: string): Promise<ContentTopicSource> {
    return request<ContentTopicSource>(
      `/coach/admin/content/topics/${encodeURIComponent(topicId)}/source`,
      { method: 'GET' },
    )
  },
}
